import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=2eaf7d5a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eaf7d5a')) {
      api.createRecord('2eaf7d5a', component.options)
    } else {
      api.reload('2eaf7d5a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=2eaf7d5a&", function () {
      api.rerender('2eaf7d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20POGN8p11L2j/JS/comp/childrenage.vue"
export default component.exports